import { render, staticRenderFns } from "./view-messages-tab.vue?vue&type=template&id=3b326958"
import script from "./view-messages-tab.vue?vue&type=script&lang=js"
export * from "./view-messages-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b326958')) {
      api.createRecord('3b326958', component.options)
    } else {
      api.reload('3b326958', component.options)
    }
    module.hot.accept("./view-messages-tab.vue?vue&type=template&id=3b326958", function () {
      api.rerender('3b326958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/campaign/view-messages-tab.vue"
export default component.exports